import axios from 'axios';

// Create an Axios instance with default configurations
const axiosInstance = axios.create({
    //baseURL: 'http://192.168.25.70:5000/api', // Set your backend base URL here
    // timeout: 10000, // Optional timeout (10 seconds)
    //baseURL: 'https://mlm.devm2.com/api',
    baseURL: 'https://learn-mt.com/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptors to handle token-based authentication (if needed)
axiosInstance.interceptors.request.use(
    (config) => {
        // Add Authorization token to headers if available
        const token = localStorage.getItem('auth_token'); // Get token from local storage or state
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Handle errors globally here, such as redirecting to login on 401
        if (error.response && error.response.status === 401) {
            // Optional: Handle Unauthorized error, e.g., redirect to login
            // window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
